import { useEffect } from "react";
import { useColorMode } from "@chakra-ui/react";

export default function ThemeColorSetter() {
  const { colorMode } = useColorMode();

  useEffect(() => {
    const themeColor = colorMode === "light" ? "#fff4ec" : "#1F1D34";

    let metaTag = document.querySelector("meta[name=theme-color]");
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "theme-color");
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute("content", themeColor);
  }, [colorMode]);

  return null;
}
